import { render, staticRenderFns } from "./sports_admin.vue?vue&type=template&id=413f184a&scoped=true"
import script from "./sports_admin.vue?vue&type=script&lang=js"
export * from "./sports_admin.vue?vue&type=script&lang=js"
import style0 from "./sports_admin.vue?vue&type=style&index=0&id=413f184a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413f184a",
  null
  
)

export default component.exports